import * as React from 'react';

import PageNavigation from 'components/common/PageNavigation';
import Routes from 'routing/Routes';
import { Row } from 'components/bootstrap';

const ArchivePageNavigation = () => {
  const NAV_ITEMS = [
    { title: 'Overview', path: Routes.pluginRoute('SYSTEM_ARCHIVES'), exactPathMatch: true },
    {
      title: 'Configuration',
      path: Routes.pluginRoute('SYSTEM_ARCHIVES_CONFIGURATION'),
      permissions: 'archiveconfig:update',
    },
    {
      title: 'Manage Backends',
      path: Routes.pluginRoute('SYSTEM_ARCHIVES_BACKENDS'),
      permissions: 'archiveconfig:update',
    },
  ];

  return (
    <Row>
      <PageNavigation items={NAV_ITEMS} />
    </Row>
  );
};

export default ArchivePageNavigation;
